import { ComponentType, lazy } from 'react';

interface IntegrationSettingsComponent {
  integrationName: string;
}

const integrationComponents: Record<string, ComponentType<IntegrationSettingsComponent>> = {
  slack: lazy(() => import('./slack/slack-settings').then((module) => ({ default: module.SlackSettings }))),
};

export function getIntegrationSettings(
  integrationName: string
): ComponentType<IntegrationSettingsComponent> | null {
  const normalizedName = integrationName.toLowerCase();
  return integrationComponents[normalizedName] || null;
}

export function hasIntegrationSettings(integrationName: string): boolean {
  const normalizedName = integrationName.toLowerCase();
  return normalizedName in integrationComponents;
}
